/**
 * Public tracking surface for components/hooks/sagas that emit business events.
 *
 * Importing from this module (instead of `util/emitter` directly) guarantees
 * that vendor subscribers are in the bundle's module graph, so they attach to
 * the emitter before any `emit` call in the same bundle can fire.
 *
 * Each AEM scene is a separately bundled island (see `index.ts`). Without this
 * module, islands that emit (lister, PDP, basket saga) wouldn't pull in the
 * Bloomreach subscriber — it only loads via Bootstrap, causing a race where
 * the first emission can arrive before the subscriber has attached and be lost.
 *
 * Add new vendor subscribers here as side-effect imports.
 */
import '../bloomreach/subscriber';
export { emitter, EmitterEvent } from '../emitter';
